import React from 'react';
import LiveNavbar from './LiveNavbar';
import { Container, Row, Col } from 'react-bootstrap';
import TopNav from '../nav/TopNav';
import MainFooter from '../nav/MainFooter';
import banner from '../../../images/jail.PNG';

const LiveBuyTickets = () => {
  return (
    <Container className='LiveBuyTickets p-0' fluid>
      <TopNav />
      <LiveNavbar />
      <Container className='my-5'>
        <Row className=''>
          <Col md={4} className='mb-5'>
            <h2 className='text-light LiveBuyTickets-heading'>
              Throwdown Chapter V: Laser Jail
            </h2>
            <div className='LiveBuyTickets-banner'>
              <img src={banner} alt='' width='100%' height='100%' />
            </div>
          </Col>

          <Col xl={8} className='my-2 '>
            <Row>
              <p className='text-light text-capitalize my-1 pl-2 '>
                select venue
              </p>
            </Row>
            <Row className='text-light LiveBuyTickets-btns'>
              <Col className='py-1 btn btn-tickets '>
                Delhi <p className='m-0'>12 March</p>
              </Col>
              <Col className='py-1 btn btn-tickets '>
                Mumbai <p className='m-0'>13 March</p>
              </Col>
              <Col className='py-1 btn btn-tickets '>
                Chandigarh <p className='m-0'>15 March</p>
              </Col>
              <Col className='py-1 btn btn-tickets '>
                Pune <p className='m-0'>17 March</p>
              </Col>
            </Row>

            <div className='spacer'>
              <Row>
                <p className='text-light text-capitalize my-1 pl-2 '>
                  category
                </p>
              </Row>
              <Row>
                <Col className='p-0'>
                  <button className='text-capitalize btn border border-dark special-btn'>
                    early bird
                    <p className='m-0 text-uppercase text-dark special-btn-text'>
                      sold out
                    </p>
                  </button>
                  <button className='btn border border-light text-capitalize spacer-x bg-light '>
                    phase i
                  </button>
                </Col>
              </Row>
            </div>

            <div className='spacer'>
              <Row>
                <p className='text-light text-capitalize my-1 pl-2 '>
                  quantity
                </p>
              </Row>
              <Row>
                <button className='btn border border-light text-light'>
                  - 2 +
                </button>
              </Row>
            </div>

            <Row>
              <button className='btn LiveBuyTickets-btn text-capitalize'>
                buy tickets
              </button>
            </Row>
          </Col>
        </Row>
      </Container>
      <MainFooter />
    </Container>
  );
};
export default LiveBuyTickets;
